import {useCallback} from 'react'
import {useChatbotContext} from '../../context'
import {
  FORMAT_CHATBOT_DATE_TIME,
  MESSAGE_TYPE,
  MessageItemCommonProps,
  MessageOption,
  SENDER_TYPE,
} from '../../definitions'
import {v4 as uuid} from 'uuid'
import moment from 'moment'
import {OutlineButton} from './OutlineButton'

type MessageItemOptionSelectProps = MessageItemCommonProps<MessageOption[]> & {
  hasUseIntl?: boolean
}
export const MessageItemOptionSelect = ({message}: MessageItemOptionSelectProps) => {
  const {addMessage, handleCreateMessage, disabledUserAction} = useChatbotContext()

  const onClickOption = useCallback(
    (option: MessageOption) => {
      if (disabledUserAction) return
      const newMessageId = uuid()

      addMessage({
        id: newMessageId,
        content: option.label,
        sender: SENDER_TYPE.USER,
        type: MESSAGE_TYPE.TEXT,
        created_at: moment.utc().format(FORMAT_CHATBOT_DATE_TIME),
      })

      handleCreateMessage({
        type: MESSAGE_TYPE.OPTION_SELECT,
        message: option,
        newMessageId,
      })
    },
    [addMessage, disabledUserAction, handleCreateMessage]
  )

  return (
    <div className='d-flex flex-column gap-3'>
      {(message?.content || []).map((option) => (
        <OutlineButton
          key={option.label}
          onClick={() => onClickOption(option)}
          title={option.label}
          disabled={disabledUserAction}
        />
      ))}
    </div>
  )
}
